module.exports = __webpack_public_path__ + "static/media/fn1.4a259a90.png";